import axios from 'axios';
import querystring from 'querystring';

export function deleteContact(contactId) {
  return axios.post('/api/?entity=contacts&action=delete', querystring.stringify({contactId}));
}
